export default "__VITE_ASSET__c3c97ff6__"